import { DEFAULT_NOTE_CHARACTER_LIMIT } from "~/constants";

import { NoteEditorModal } from "../noteEditorModal/NoteEditorModal";

import type {
  NoteEditorData,
  NoteEditorModalSaveEvent,
} from "../noteEditorModal/NoteEditorModal";

export interface WatchViewNoteEditorProps {
  color?: NoteEditorData["color"];
  id: string;
  initialValue?: NoteEditorData["value"] | null;
  isOpen?: boolean;
  timestamp?: number | null;
  title?: string;
  onCancel?: () => void;
  onDraftSave?: (event: NoteEditorModalSaveEvent) => Promise<void>;
  onRequestClose?: () => void;
  onSave?: (event: NoteEditorModalSaveEvent) => Promise<void>;
}

export function WatchViewNoteEditor({
  color,
  id,
  initialValue,
  isOpen,
  timestamp,
  title,
  onCancel,
  onDraftSave,
  onRequestClose,
  onSave,
}: WatchViewNoteEditorProps) {
  return (
    <NoteEditorModal
      color={color}
      id={id}
      initialValue={initialValue ?? undefined}
      isOpen={isOpen}
      limit={DEFAULT_NOTE_CHARACTER_LIMIT}
      resetAfterSave
      timestamp={timestamp ?? undefined}
      title={title}
      onCancel={onCancel}
      onDraftSave={onDraftSave}
      onRequestClose={onRequestClose}
      onSave={onSave}
    />
  );
}
